import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useTemplatePicker = defineStore('template-picker', () => {
  const isVisible = ref(false);
  return { isVisible };
});
